import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { DataService } from '../data.service';
import { KozosCegService } from '../kozos-ceg.service';

/*  TÁRGYI ESZKÖZ – az aktív ügyfél és év. A modul a NAPLO ügyféltörzsével dolgozik (közös adat),
 *  ezért induláskor a Könyvelésben utoljára választott ügyfelet és évet veszi át, ha nincs saját
 *  választás. A két modul innentől külön emlékszik (a Könyvelésben ügyfelet váltani ne vigye el
 *  az itt nyitott eszközöket, és fordítva). Minden kérés a /api/eszkoz alá megy (ESZKOZ-kapu). */
export interface EszkozAktiv {
  intezmeny: string;
  ugyfelId: string | null;
  ugyfelNev: string | null;
  ev: number;
  konyveles_mod: string;          // 'kettos' → a feladás a főkönyvbe is megy
}

@Injectable({ providedIn: 'root' })
export class EszkozService {
  aktiv$ = new BehaviorSubject<EszkozAktiv>({ intezmeny: '', ugyfelId: null, ugyfelNev: null, ev: new Date().getFullYear(), konyveles_mod: 'egyszeres' });
  get aktiv(): EszkozAktiv { return this.aktiv$.value; }
  private kesz = false;

  constructor(private http: HttpClient, private data: DataService, private kozos: KozosCegService) {}

  async init(): Promise<EszkozAktiv> {
    if (this.kesz) return this.aktiv;
    const si = await this.data.getFromStorage('sajatIntezmeny');
    const sajat = (await this.data.getFromStorage('eszkozAktiv')) || null;
    const naplo = (await this.data.getFromStorage('naploAktiv')) || {};
    const m = sajat || naplo;
    this.aktiv$.next({
      intezmeny: si?.intezmenyId || '',
      ugyfelId: m.ugyfelId || null, ugyfelNev: m.ugyfelNev || null,
      ev: m.ev || new Date().getFullYear(), konyveles_mod: m.konyveles_mod || 'egyszeres',
    });
    this.kesz = true;
    return this.aktiv;
  }
  async setAktiv(patch: Partial<EszkozAktiv>) {
    const a = { ...this.aktiv, ...patch };
    this.aktiv$.next(a);
    await this.data.setStorage('eszkozAktiv', { ugyfelId: a.ugyfelId, ugyfelNev: a.ugyfelNev, ev: a.ev, konyveles_mod: a.konyveles_mod });
    if (a.ugyfelId) await this.kozos.jelol('ESZKOZ', a.ugyfelId);
  }
  /*  MODULBA LÉPÉSKOR: a Könyvelésben / Bérben épp aktív cég legyen kiválasztva (ugyanaz a törzs),
   *  ne az itt legutóbb választott. */
  async kozosAtvesz(): Promise<void> {
    const id = await this.kozos.atveendo('ESZKOZ');
    if (id && id !== this.aktiv.ugyfelId && this.aktiv.intezmeny) {
      try {
        const lista: any[] = await this.getAbs(`/api/eszkoz/ugyfelek/${this.aktiv.intezmeny}`);
        const u = lista.find((x) => x.id === id && !x.inaktiv);
        if (u) await this.setAktiv({ ugyfelId: u.id, ugyfelNev: u.nev, konyveles_mod: u.konyveles_mod || 'egyszeres' });
      } catch { /* marad a legutóbbi */ }
    }
    if (this.aktiv.ugyfelId) await this.kozos.jelol('ESZKOZ', this.aktiv.ugyfelId);
  }

  getAbs<T = any>(path: string): Promise<T> { return firstValueFrom(this.http.get<T>(path)); }
  postAbs<T = any>(path: string, body: any = {}): Promise<T> { return firstValueFrom(this.http.post<T>(path, body)); }
  delAbs<T = any>(path: string): Promise<T> { return firstValueFrom(this.http.delete<T>(path)); }
  putAbs<T = any>(path: string, body: any = {}): Promise<T> { return firstValueFrom(this.http.put<T>(path, body)); }
}
